import { BottomNav } from '../Nav/BottomNav/BottomNav';
import LimitedNav from '../Nav/Limited-nav/Limited-nav';
import { PopupWindowPropsModel } from './popup-window-props.model';
import './Popup-window.css';

const PopupWindow = (props: PopupWindowPropsModel) => {
  const handleTooltipIconClick = () => {
    if (props.onTooltipIconClick) {
      props.onTooltipIconClick();
    }
  };

  const handleBackClick = () => {
    if (props.onBackClick) {
      props.onBackClick();
    }
  };

  const handleContinueClick = () => {
    if (props.onContinueClick && !props.isNavigationDisabled) {
      props.onContinueClick();
    }
  };

  return (
    <>
      {props.showTopNavigation && (
        <LimitedNav
          className="fixed top-0 left-0 z-90"
          showTooltipIcon={props.showTooltipIcon}
          onTooltipIconClick={handleTooltipIconClick}
        />
      )}
      <div className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen z-80">
        <div
          className={`relative flex flex-col items-center justify-center rounded-xl min-w-sm max-w-600 bg-white 
              dark:bg-grey-90
              dark:text-white
              dark:border-grey-80
             ${props.customPaddings ? props.customPaddings : 'p-14'} ${
            props.className || ''
          }`}
        >
          <div
            className="absolute flex items-center justify-center w-5 h-5 cursor-pointer top-5 right-5"
            onClick={() => {
              if (props.onCloseClick) {
                props.onCloseClick();
              }
            }}
          >
            <span className="material-icons text-xl">close</span>
          </div>
          <img src={props.popupIcon || ''} alt="" />
          <h1
            className={`${
              props.popupIcon && 'mt-6'
            } text-black dark:text-white text-xl font-semibold text-center`}
          >
            {props.title || ''}
          </h1>
          <p
            className={`${
              props.subtitle && 'mt-4'
            } text-grey-50 text-sm max-w-xs text-center`}
          >
            {props.subtitle || ''}
          </p>
          {props.children}
          {props.showBottomNavigation && (
            <div className="relative w-full h-18 min-h-18">
              <BottomNav
                className="h-18 min-h-18 rounded-b-xl"
                setPositionAbsolute
                showBackButton={
                  props.showBackButton ||
                  (props.currentState ? props.currentState > 0 : false)
                }
                isNavigationDisabled={props.isNavigationDisabled}
                onBackClick={handleBackClick}
                onContinueClick={handleContinueClick}
                isContinueButtonLoading={props.isContinueButtonLoading}
              />
            </div>
          )}
        </div>
      </div>
      <div className="fixed top-0 left-0 w-screen h-screen z-70 bg-black-backdrop" />
    </>
  );
};

export default PopupWindow;
